// import React, { useState, useMemo } from "react";
// import styled from "styled-components";
// import ArticleModal from "./ArticleModal"; // Ensure the correct path

// // Import images
// import Xarticle0 from "../../images/Xarticle0.png";
// import Xarticle1 from "../../images/Xarticle1.png";
// import Xarticle2 from "../../images/Xarticle2.png";
// import Xarticle3 from "../../images/Xarticle3.png";
// import Xarticle4 from "../../images/Xarticle4.png";
// import Xarticle5 from "../../images/Xarticle5.png";
// import Xarticle6 from "../../images/Xarticle6.png";
// import Xarticle7 from "../../images/Xarticle7.png";
// import Xarticle8 from "../../images/Xarticle8.png";
// import Xarticle9 from "../../images/Xarticle9.png";
// import Xarticle10 from "../../images/Xarticle10.png";
// import Xarticle11 from "../../images/Xarticle11.png";
// import Xarticle12 from "../../images/Xarticle12.png";
// import Xarticle13 from "../../images/Xarticle13.png";
// import Xarticle14 from "../../images/Xarticle14.png";
// import Xarticle15 from "../../images/Xarticle15.png";
// import Xarticle16 from "../../images/Xarticle16.png";
// import Xarticle17 from "../../images/Xarticle17.png";
// import Xarticle18 from "../../images/Xarticle18.png";
// import Xarticle19 from "../../images/Xarticle19.png";
// import Xarticle20 from "../../images/Xarticle20.png";
// import Xarticle21 from "../../images/Xarticle21.png";
// import Xarticle22 from "../../images/Xarticle22.png";
// import Xarticle23 from "../../images/Xarticle23.png";
// import Xarticle24 from "../../images/Xarticle24.png";
// import Xarticle25 from "../../images/Xarticle25.png";
// import Xarticle26 from "../../images/Xarticle26.png";
// import Xarticle27 from "../../images/Xarticle27.png";
// import Xarticle28 from "../../images/Xarticle28.png";
// import Xarticle29 from "../../images/Xarticle29.png";
// import Xarticle30 from "../../images/Xarticle30.png";
// import Xarticle31 from "../../images/Xarticle31.png";
// import Xarticle32 from "../../images/Xarticle32.png";
// import Xarticle33 from "../../images/Xarticle33.png";
// import Xarticle34 from "../../images/Xarticle34.png";
// import Xarticle35 from "../../images/Xarticle35.png";
// import Xarticle36 from "../../images/Xarticle36.png";
// import Xarticle37 from "../../images/Xarticle37.png";
// import Xarticle38 from "../../images/Xarticle38.png";
// import BackgroundImage from "../../images/VoicePageBG.png";
// import BottomImage from "../../images/carljungDalleIMG.png";

// // ──────────────────────────────────────────────────────────────────────────────
// // Styled Components ────────────────────────────────────────────────────────────
// // ──────────────────────────────────────────────────────────────────────────────

// const PageBackground = styled.div`
//   position: fixed;
//   inset: 0;
//   background: url(${BackgroundImage}) center / cover no-repeat fixed;
//   z-index: -2;
// `;

// const MainContainer = styled.div`
//   position: relative;
//   min-height: 100vh;
//   padding: 2rem 1rem;
//   z-index: 1;
// `;

// const FilterBar = styled.div`
//   display: flex;
//   justify-content: center;
//   margin: 1.5rem 0 2.5rem;
// `;

// const TopicSelect = styled.select`
//   min-width: 240px;
//   padding: 0.75rem 2.8rem 0.75rem 1rem;
//   font-size: 1.05rem;
//   font-family: system-ui, sans-serif;
//   color: #52ff55;
//   background: rgba(20, 20, 20, 0.65);
//   border: 1px solid #52ff55;
//   border-radius: 8px;
//   backdrop-filter: blur(8px);
//   -webkit-backdrop-filter: blur(8px);
//   cursor: pointer;
//   appearance: none;
//   background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2352ff55' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
//   background-repeat: no-repeat;
//   background-position: right 0.8rem center;

//   &:focus {
//     outline: none;
//     box-shadow: 0 0 0 3px rgba(82, 255, 85, 0.25);
//   }
// `;

// const CardsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 24px;
//   max-width: 1440px;
//   margin: 0 auto;
//   padding: 0 16px;
//   justify-items: center;           /* helps center cards when fewer than 4 */

//   /* Force max 4 columns on wide screens */
//   @media (min-width: 1200px) {
//     grid-template-columns: repeat(4, minmax(280px, 1fr));
//     max-width: 1280px;             /* or 1400px — adjust to taste */
//   }

//   /* Tablet - up to 3 columns */
//   @media (min-width: 900px) and (max-width: 1199px) {
//     grid-template-columns: repeat(3, minmax(280px, 1fr));
//   }

//   /* Small tablet / large phone - 2 columns */
//   @media (min-width: 600px) and (max-width: 899px) {
//     grid-template-columns: repeat(2, minmax(280px, 1fr));
//   }

//   /* Phone - 1 column */
//   @media (max-width: 599px) {
//     grid-template-columns: 1fr;
//     gap: 20px;
//     padding: 0 12px;
//   }
// `;

// // Keep Card mostly the same, just make sure it doesn't stretch weirdly
// const Card = styled.button.attrs({ type: 'button' })`
//   position: relative;
//   width: 100%;
//   aspect-ratio: 1 / 1;
//   max-width: 360px;                   // ← important: prevents single card from becoming huge
//   overflow: hidden;
//   border: 1px solid #52ff55;
//   border-radius: 12px;
//   background: #0a0a0a;
//   cursor: pointer;
//   transition: all 0.28s ease;
//   box-shadow: 0 4px 15px rgba(0,0,0,0.4);

//   &:hover {
//     transform: translateY(-6px) scale(1.03);
//     box-shadow: 0 12px 32px rgba(82, 255, 85, 0.18);
//   }

//   &:active {
//     transform: scale(0.98);
//   }
//    @media (max-width: 599px) {
//     max-width: 100%;
//   }
// `;

// const CardImage = styled.img`
//   position: absolute;
//   inset: 0;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   object-position: center;
// `;

// // Keep the black overlay on hover (as in original)
// const TitleOverlay = styled.div`
//   position: absolute;
//   inset: 0;
//   display: flex;
//   align-items: center;               // centered vertically + horizontally
//   justify-content: center;
//   padding: 20px;
//   background: rgba(0, 0, 0, 0);      // transparent by default
//   color: #52ff55;
//   font-family: "VT323", "Courier New", Courier, monospace;
//   font-size: clamp(1.1rem, 2.8vw, 1.6rem);
//   font-weight: 500;
//   line-height: 1.3;
//   text-align: center;
//   /* text-shadow: 0 1px 6px #000, 0 0 12px rgba(82,255,85,0.6); */
//   transition: background 0.25s ease, opacity 0.25s ease;
//   opacity: 0;

//   ${Card}:hover & {
//     background: rgba(0, 0, 0, 1);  // ← solid black-ish on hover
//     opacity: 1;
//   }

//   /* On touch devices show title always (better mobile UX) */
//   @media (hover: none) {
//     background: rgba(0, 0, 0, 0.75);
//     opacity: 1;
//     align-items: flex-end;
//     padding-bottom: 1.4rem;
//   }
// `;

// const ReadButton = styled.span`
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   padding: 0.9rem;
//   background: #52ff55;
//   color: #000;
//   font-weight: bold;
//   font-size: 0.95rem;
//   text-align: center;
//   cursor: pointer;
//   z-index: 2;
//   transition: background 0.2s;

//   &:hover {
//     background: #6fff6f;
//   }
// `;

// // ──────────────────────────────────────────────────────────────────────────────
// // Component ────────────────────────────────────────────────────────────────────
// // ──────────────────────────────────────────────────────────────────────────────

// const ArticlesGallery = () => {
//   const [selectedTopic, setSelectedTopic] = useState("all");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [activeArticle, setActiveArticle] = useState(null);

//   const articles = useMemo(() => [
//     {
//       id: 38,
//       link: "https://x.com/jrq3rq/status/1994968885997834701?s=20",
//       imageSrc: Xarticle38,
//       title: "The Most Beautiful Use of AI Nobody Is Talking About",
//       showButton: false,
//       topics: ["ai", "culture", "preservation", "innovation", "humanity"]
//     },
//     {
//       id: 37,
//       link: "https://x.com/jrq3rq/status/1981435574759120987",
//       imageSrc: Xarticle37,
//       title: "Insight Without Intrusion: How Psychological Assessments Protect Student Privacy",
//       showButton: false,
//       topics: ["ai", "education", "psychology", "privacy", "innovation"]
//     },
//     {
//       id: 36,
//       link: "https://x.com/jrq3rq/status/1942634182209069127",
//       imageSrc: Xarticle36,
//       title: "Simple Agents, Big Wins: How Small AI Agents Can Transform Your Business",
//       showButton: false,
//       topics: ["business", "ai", "innovation", "technology", "automation"]
//     },
//     {
//       id: 35,
//       link: "https://x.com/jrq3rq/status/1942609360565461411",
//       imageSrc: Xarticle35,
//       title: "Why Smart Ideas Die Without Systems: Why even the best sparks need a plan to soar.",
//       showButton: false,
//       topics: ["business", "innovation", "strategy", "systems-thinking"]
//     },
//     {
//       id: 34,
//       link: "https://x.com/jrq3rq/status/1939256462532124973",
//       imageSrc: Xarticle34,
//       title: "Voices of the Magi: A Spiritual Calling in Code",
//       showButton: false,
//       topics: ["religious", "spirituality", "technology", "ai"]
//     },
//     {
//       id: 33,
//       link: "https://x.com/jrq3rq/status/1936664416122208528",
//       imageSrc: Xarticle33,
//       title: "A Blueprint for Healing Earth: Technologies for a Thriving Planet",
//       showButton: false,
//       topics: ["environment", "sustainability", "innovation"]
//     },
//     {
//       id: 32,
//       link: "https://x.com/jrq3rq/status/1916706569884172749",
//       imageSrc: Xarticle32,
//       title: "AI-Generated Article — Depth Over Trends: How to Build Success That Lasts",
//       showButton: false,
//       topics: ["strategy", "success"]
//     },
//     {
//       id: 31,
//       link: "https://x.com/jrq3rq/status/1915260038807220678",
//       imageSrc: Xarticle31,
//       title: "AI-Generated Article — Self-Marketing for Introverts: How to Be Seen Without Selling Your Soul",
//       showButton: false,
//       topics: ["self-marketing", "individuality", "personality", "psychology"]
//     },
//     {
//       id: 30,
//       link: "https://x.com/jrq3rq/status/1904728233649856711",
//       imageSrc: Xarticle30,
//       title: "Introducing Homeschool Guide: AI Tools for Neurodivergent-Friendly Homeschooling",
//       showButton: false,
//       topics: ["ai", "innovation", "autism", "neurodiversity"]
//     },
//     {
//       id: 29,
//       link: "https://x.com/jrq3rq/status/1903514303933936056",
//       imageSrc: Xarticle29,
//       title: "Why Your AI Art Keeps Drawing the Wrong Thing — The Power of Priming",
//       showButton: false,
//       topics: ["ai", "technology", "psychology", "user-experience", "art", "innovation"]
//     },
//     {
//       id: 28,
//       link: "https://x.com/jrq3rq/status/1902089229485920272",
//       imageSrc: Xarticle28,
//       title: "The Future of Knowledge – Why We’ll Pay to Chat with AI Einsteins",
//       showButton: false,
//       topics: ["ai", "technology", "innovation", "user-experience", "entertainment", "monetization"]
//     },
//     {
//       id: 27,
//       link: "https://x.com/jrq3rq/status/1842974661480710531",
//       imageSrc: Xarticle27,
//       title: "The Essence of Enchanting Retail: Bringing Back the Magic in Modern Small Shops",
//       showButton: false,
//       topics: ["retail", "small business", "customer-experience", "sustainability", "innovation", "technology", "experiential-design"]
//     },
//     {
//       id: 26,
//       link: "https://x.com/jrq3rq/status/1842292716996276693",
//       imageSrc: Xarticle26,
//       title: "Revolutionizing Play: The Integration of AI in the Toy Industry",
//       showButton: false,
//       topics: ["ai", "toys", "education", "personalization"]
//     },
//     {
//       id: 24,
//       link: "https://x.com/jrq3rq/status/1840806509292503212",
//       imageSrc: Xarticle24,
//       title: "The Art of Being Uniquely You: Harnessing Individuality in Creativity",
//       showButton: false,
//       topics: ["creativity", "individuality", "psychology", "personal-development"]
//     },
//     {
//       id: 23,
//       link: "https://x.com/jrq3rq/status/1827134562801218044",
//       imageSrc: Xarticle23,
//       title: "Creating the Future of Experiential Spaces: A Modular, Multi-Sensory Environment",
//       showButton: false,
//       topics: ["innovation", "technology", "retail", "museums", "adaptive-experiential-design", "ar"]
//     },
//     {
//       id: 22,
//       link: "https://x.com/jrq3rq/status/1823894563440013781",
//       imageSrc: Xarticle22,
//       title: "The Intersection of Art and AI: Navigating New Frontiers in Creative Expression ",
//       showButton: false,
//       topics: ["ai", "art", "innovation"]
//     },
//     {
//       id: 21,
//       link: "https://x.com/jrq3rq/status/1818330358745874787",
//       imageSrc: Xarticle21,
//       title: "Holographic Storytelling: Interactive Holograms for History and Art ",
//       showButton: false,
//       topics: ["holography", "art", "museums", "technology", "innovation"]
//     },
//     {
//       id: 14,
//       link: "https://x.com/jrq3rq/status/1813033783224070539",
//       imageSrc: Xarticle14,
//       title: "From Retail Ruins to Museums: How to Transform America's Abandoned Malls",
//       showButton: false,
//       topics: ["art", "museums", "business", "innovation", "urban-planning"]
//     },
//     {
//       id: 19,
//       link: "https://x.com/12jungian/status/1811872575007654071",
//       imageSrc: Xarticle19,
//       title: "Transforming Today's Museums into Tomorrow's Ivy League: AI as an Educational Tool",
//       showButton: false,
//       topics: ["ai", "museums", "education", "technology", "innovation"]
//     },
//     {
//       id: 20,
//       link: "https://x.com/12jungian/status/1812556682624643569",
//       imageSrc: Xarticle20,
//       title: "Part 2: Beyond AI – Reshaping the Future of Museums with a Comprehensive Vision",
//       showButton: false,
//       topics: ["museums", "innovation", "technology", "art", "education"]
//     },
//     {
//       id: 15,
//       link: "https://x.com/jrq3rq/status/1814799275647508916",
//       imageSrc: Xarticle15,
//       title: "The Role and Evolution of Non-Profits in America: A Comprehensive Guide",
//       showButton: false,
//       topics: ["business", "leadership", "social-impact", "innovation"]
//     },
//     {
//       id: 16,
//       link: "https://x.com/jrq3rq/status/1806108757203747184",
//       imageSrc: Xarticle16,
//       title: "The Dangers of Overconfidence: How Thinking You Know Everything Can Lead to Failure",
//       showButton: false,
//       topics: ["psychology", "leadership", "business", "personal-development"]
//     },
//     {
//       id: 13,
//       link: "https://x.com/jrq3rq/status/1809369493568909601",
//       imageSrc: Xarticle13,
//       title: "Unlocking Potential: Mastering the Art of Constructive Questioning",
//       showButton: false,
//       topics: ["leadership", "psychology", "innovation", "business"]
//     },
//     {
//       id: 17,
//       link: "https://x.com/jrq3rq/status/1807206985802436854",
//       imageSrc: Xarticle17,
//       title: "The Lost Magic: Rediscovering the Soul of Walt Disney's World",
//       showButton: false,
//       topics: ["entertainment", "business", "innovation", "art"]
//     },
//     {
//       id: 18,
//       link: "https://x.com/jrq3rq/status/1808322265102405899",
//       imageSrc: Xarticle18,
//       title: "Understanding the Importance of Skill Development",
//       showButton: false,
//       topics: ["personal-development", "education", "business", "career"]
//     },
//     {
//       id: 12,
//       link: "https://x.com/jrq3rq/status/1805414687204688147",
//       imageSrc: Xarticle11,
//       title: "Embracing the Infinite: Psychological Patterns in Data Analysis",
//       showButton: false,
//       topics: ["psychology", "data-analysis"]
//     },
//     {
//       id: 11,
//       link: "https://x.com/jrq3rq/status/1804279451192299531",
//       imageSrc: Xarticle9,
//       title: "Embracing the Infinite: Finding Patterns in a Data-Rich World",
//       showButton: false,
//       topics: ["data-analysis"]
//     },
//     {
//       id: 1,
//       link: "https://x.com/12jungian/status/1797332069313569091",
//       imageSrc: Xarticle1,
//       title: "Unveiling the Mythic Roots: The Journey of Jungian Archetypes",
//       showButton: true,
//       topics: ["psychology", "jungian archetypes"],
//       content: `
//        <h2>Unveiling the Mythic Roots: The Journey of Jungian Archetypes</h2>
//         <p>In the vast landscape of psychological exploration, few figures loom as large as Carl Gustav Jung. Jung's pioneering work delved into the depths of the human psyche, unraveling mysteries that had long confounded scholars and laypeople alike. Central to Jung's framework are his theories on archetypes, symbolic patterns deeply ingrained in the collective unconscious of humanity. This article embarks on a journey through the mythic roots of Jungian archetypes, shedding light on their origins, significance, and practical applications in contemporary society.</p>
//         <h3>The Collective Unconscious</h3>
//         <p>At the core of Jungian psychology lies the concept of the collective unconscious, a reservoir of shared experiences, symbols, and archetypes that transcends individuality. Within this vast repository, archetypes serve as primordial templates, shaping our perceptions, behaviors, and cultural narratives. Through exploring the collective unconscious, we gain insights into the universal aspects of the human condition, uncovering the threads that bind us together across time and space.</p>
//         <h3>Mythic Origins of Archetypes</h3>
//         <p>The origins of Jungian archetypes can be traced back to the myths and legends of ancient civilizations. From the hero's epic quest for glory to the shadowy depths of the underworld, mythologies from around the world abound with archetypal motifs. These timeless tales, passed down through generations, offer glimpses into the collective soul of humanity, reflecting our deepest fears, aspirations, and desires.</p>
//         <h3>The Hero's Journey</h3>
//         <p>Among the myriad archetypes that populate the collective unconscious, none is more iconic than the hero. Embarking on a journey of trials and tribulations, the hero confronts inner and outer challenges, ultimately emerging transformed and enlightened. Through the hero's journey, individuals find resonance with their own struggles and triumphs, discovering the courage and resilience within themselves to face life's adversities.</p>
//         <h3>The Shadow and the Anima/Animus</h3>
//         <p>Yet, alongside the hero, lurks the shadow—a dark and often neglected aspect of the psyche. The shadow represents the repressed and denied parts of ourselves, manifesting in unconscious patterns of behavior and projection onto others. Similarly, the anima (the feminine aspect within men) and animus (the masculine aspect within women) embody the unconscious qualities that we seek to integrate and understand.</p>
//         <h3>Archetypes in Modern Culture</h3>
//         <p>From the pages of literature to the silver screen, archetypes permeate modern culture, shaping our stories, symbols, and societal norms. Whether in the form of the wise mentor, the femme fatale, or the rebellious outlaw, archetypal characters resonate with audiences on a profound level, tapping into universal truths and collective experiences.</p>
//         <h3>Psychological Applications of Archetypes</h3>
//         <p>Beyond their cultural significance, archetypes find practical applications in psychology, therapy, and personal development. Therapists utilize archetypal imagery and storytelling to help clients explore and integrate unconscious aspects of their psyche, facilitating healing and transformation. Similarly, personality assessments and self-discovery tools draw upon archetypal frameworks to provide insights into individuals' motivations, strengths, and challenges.</p>
//         <h3>Archetypes in Everyday Life</h3>
//         <p>In our daily lives, we encounter archetypal patterns in myriad forms, from the nurturing caregiver to the ambitious entrepreneur. These archetypes shape our identities, relationships, and societal roles, influencing how we perceive ourselves and interact with others. By recognizing archetypal dynamics at play, we gain a deeper understanding of human behavior and collective dynamics.</p>
//         <h3>The Evolution of Archetypes</h3>
//         <p>As society evolves and cultural landscapes shift, archetypes adapt and evolve alongside them. New archetypal figures emerge, reflecting changing social norms, values, and aspirations. Yet, beneath the surface, the core essence of archetypes remains unchanged, serving as timeless symbols of the human experience.</p>
//         <h3>Embracing the Archetypal Journey</h3>
//         <p>In embracing the archetypal journey, we embark on a path of self-discovery, introspection, and personal growth. By exploring our own archetypal narratives and patterns, we gain insights into our deepest motivations, fears, and potentials. Through this process of integration and individuation, we move towards wholeness and authenticity, aligning with the transformative power of Jungian archetypes.</p>
//         <h3>Critique and Counterarguments</h3>
//         <p>While Jung's theories on archetypes have had a profound impact on psychology and culture, they are not without critique. Critics argue that archetypes may not be universally applicable, and their meanings may vary significantly across cultures and contexts. Some scholars emphasize the role of broader social and cultural factors that shape human behavior, suggesting that archetypes alone may not fully account for the complexity of the human experience. Despite these criticisms, Jungian archetypes continue to inspire and provoke thought, inviting further exploration and dialogue within the field of psychology and beyond.</p>
//       `,
//       bottomImage: BottomImage
//     },
//     {
//       id: 2,
//       link: "https://x.com/12jungian/status/1797776932492513301",
//       imageSrc: Xarticle3,
//       title: "Unveiling the Power of Jungian Archetypes: Discovering Business Identity",
//       showButton: false,
//       topics: ["psychology", "jungian archetypes", "business"]
//     },
//     {
//       id: 3,
//       link: "https://x.com/12jungian/status/1798465206026391646",
//       imageSrc: Xarticle2,
//       title: "Unveiling Creative Potential: Harnessing Archetypes for Innovation and Growth",
//       showButton: false,
//       topics: ["psychology", "innovation"]
//     },
//     {
//       id: 4,
//       link: "https://x.com/jrq3rq/status/1791638597210435907",
//       imageSrc: Xarticle0,
//       title: "Enhancing AI Alignment with Jungian Archetypes",
//       showButton: false,
//       topics: ["ai", "psychology", "jungian archetypes"]
//     },
//     {
//       id: 5,
//       link: "https://x.com/jrq3rq/status/1803818318215962710",
//       imageSrc: Xarticle5,
//       title: "Reimagining the Past for the Future: How 2D Nostalgic Games Can Thrive in Web 3",
//       showButton: false,
//       topics: ["gaming", "web3"]
//     },
//     {
//       id: 6,
//       link: "https://x.com/jrq3rq/status/1796719807360127156",
//       imageSrc: Xarticle4,
//       title: "Revolutionizing the World: The Transformative Power of AI",
//       showButton: false,
//       topics: ["ai", "technology"]
//     },
//     {
//       id: 7,
//       link: "https://x.com/jrq3rq/status/1791210906015166705",
//       imageSrc: Xarticle6,
//       title: "Interactive Museum and Art Exhibits: Transforming Visitor Experience with AI Characters",
//       showButton: false,
//       topics: ["ai", "art", "museums"]
//     },
//     {
//       id: 8,
//       link: "https://x.com/jrq3rq/status/1801792928899285381",
//       imageSrc: Xarticle7,
//       title: "Unlocking AI's Full Potential: The Critical Role of Specialized Expertise",
//       showButton: false,
//       topics: ["ai", "expertise"]
//     },
//     {
//       id: 9,
//       link: "https://x.com/jrq3rq/status/1802513058541232262",
//       imageSrc: Xarticle8,
//       title: "Unlocking Leadership Potential: The Power of Shadow Work in Business",
//       showButton: false,
//       topics: ["psychology", "business", "leadership"]
//     },
//     {
//       id: 10,
//       link: "https://x.com/jrq3rq/status/1804312930244284748",
//       imageSrc: Xarticle10,
//       title: "How Extroverts Lead the World Built by Introverts: The Yin and Yang of Human Personalities",
//       showButton: false,
//       topics: ["psychology", "personality"]
//     }
//   ], []);

//   const allTopics = useMemo(() => {
//     const topicsSet = new Set(articles.flatMap(a => a.topics));
//     return ["all", ...Array.from(topicsSet).sort()];
//   }, [articles]);

//   const visibleArticles = useMemo(() => {
//     if (selectedTopic === "all") return articles;
//     return articles.filter(a => a.topics.includes(selectedTopic));
//   }, [articles, selectedTopic]);

//   const openXLink = (url) => {
//     window.open(url, "_blank", "noopener,noreferrer");
//   };

//   const openModal = (article) => {
//     if (article.showButton) {
//       setActiveArticle(article);
//       setModalOpen(true);
//     }
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setActiveArticle(null);
//   };

//   const handleCardClick = (article) => {
//     if (article.showButton) {
//       openModal(article);
//     } else {
//       openXLink(article.link);
//     }
//   };

//   return (
//     <>
//       <PageBackground />

//       <MainContainer id="Xarticles">
//         <FilterBar>
//           <TopicSelect
//             value={selectedTopic}
//             onChange={(e) => setSelectedTopic(e.target.value)}
//           >
//             {allTopics.map((topic) => (
//               <option key={topic} value={topic}>
//                 {topic === "all" ? "All Topics" :
//                  topic.toLowerCase() === "ai" ? "AI" :
//                  topic.charAt(0).toUpperCase() + topic.slice(1)}
//               </option>
//             ))}
//           </TopicSelect>
//         </FilterBar>

//         <CardsGrid>
//           {visibleArticles.map((article) => (
//             <Card
//               key={article.id}
//               onClick={() => handleCardClick(article)}
//               aria-label={`Open ${article.title}`}
//             >
//               <CardImage
//                 src={article.imageSrc}
//                 alt={article.title}
//                 loading="lazy"
//               />
//               <TitleOverlay>{article.title}</TitleOverlay>

//               {article.showButton && (
//                 <ReadButton
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     openModal(article);
//                   }}
//                 >
//                   Read Article
//                 </ReadButton>
//               )}
//             </Card>
//           ))}
//         </CardsGrid>
//       </MainContainer>

//       {activeArticle && (
//         <ArticleModal
//           isOpen={modalOpen}
//           onClose={closeModal}
//           bottomImage={activeArticle.bottomImage}
//         >
//           <div dangerouslySetInnerHTML={{ __html: activeArticle.content }} />
//         </ArticleModal>
//       )}
//     </>
//   );
// };

// export default ArticlesGallery;
import React, { useState, useMemo, useEffect } from "react";
import styled from "styled-components";
import ArticleModal from "./ArticleModal"; // Ensure the correct path

// Import images
import Xarticle0 from "../../images/Xarticle0.png";
import Xarticle1 from "../../images/Xarticle1.png";
import Xarticle2 from "../../images/Xarticle2.png";
import Xarticle3 from "../../images/Xarticle3.png";
import Xarticle4 from "../../images/Xarticle4.png";
import Xarticle5 from "../../images/Xarticle5.png";
import Xarticle6 from "../../images/Xarticle6.png";
import Xarticle7 from "../../images/Xarticle7.png";
import Xarticle8 from "../../images/Xarticle8.png";
import Xarticle9 from "../../images/Xarticle9.png";
import Xarticle10 from "../../images/Xarticle10.png";
import Xarticle11 from "../../images/Xarticle11.png";
import Xarticle12 from "../../images/Xarticle12.png";
import Xarticle13 from "../../images/Xarticle13.png";
import Xarticle14 from "../../images/Xarticle14.png";
import Xarticle15 from "../../images/Xarticle15.png";
import Xarticle16 from "../../images/Xarticle16.png";
import Xarticle17 from "../../images/Xarticle17.png";
import Xarticle18 from "../../images/Xarticle18.png";
import Xarticle19 from "../../images/Xarticle19.png";
import Xarticle20 from "../../images/Xarticle20.png";
import Xarticle21 from "../../images/Xarticle21.png";
import Xarticle22 from "../../images/Xarticle22.png";
import Xarticle23 from "../../images/Xarticle23.png";
import Xarticle24 from "../../images/Xarticle24.png";
import Xarticle25 from "../../images/Xarticle25.png";
import Xarticle26 from "../../images/Xarticle26.png";
import Xarticle27 from "../../images/Xarticle27.png";
import Xarticle28 from "../../images/Xarticle28.png";
import Xarticle29 from "../../images/Xarticle29.png";
import Xarticle30 from "../../images/Xarticle30.png";
import Xarticle31 from "../../images/Xarticle31.png";
import Xarticle32 from "../../images/Xarticle32.png";
import Xarticle33 from "../../images/Xarticle33.png";
import Xarticle34 from "../../images/Xarticle34.png";
import Xarticle35 from "../../images/Xarticle35.png";
import Xarticle36 from "../../images/Xarticle36.png";
import Xarticle37 from "../../images/Xarticle37.png";
import Xarticle38 from "../../images/Xarticle38.png";
import Xarticle39 from "../../images/Xarticle39.png";
import BottomImage from "../../images/carljungDalleIMG.png";

// ──────────────────────────────────────────────────────────────────────────────
// Layout switch — set to false to restore the previous square grid instantly
// ──────────────────────────────────────────────────────────────────────────────
const USE_FEATURED_LAYOUT = true;

// ──────────────────────────────────────────────────────────────────────────────
// Styled Components ────────────────────────────────────────────────────────────
// ──────────────────────────────────────────────────────────────────────────────

const MainContainer = styled.div`
  position: relative;
  min-height: 100vh;
  padding: 2rem 1rem;
  z-index: 1;
`;

const FilterBar = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.5rem 0 2.5rem;
`;

const TopicSelect = styled.select`
  min-width: 240px;
  padding: 0.75rem 2.8rem 0.75rem 1rem;
  font-size: 1.05rem;
  font-family: system-ui, sans-serif;
  color: #52ff55;
  background: rgba(20, 20, 20, 0.65);
  border: 1px solid #52ff55;
  border-radius: 8px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2352ff55' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.8rem center;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(82, 255, 85, 0.25);
  }
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 16px;
  justify-items: center;

  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, minmax(280px, 1fr));
    max-width: 1280px;
  }

  @media (min-width: 900px) and (max-width: 1199px) {
    grid-template-columns: repeat(3, minmax(280px, 1fr));
  }

  @media (min-width: 600px) and (max-width: 899px) {
    grid-template-columns: repeat(2, minmax(280px, 1fr));
  }

  @media (max-width: 599px) {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 12px;
  }
`;

const Card = styled.button.attrs({ type: "button" })`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  max-width: 360px;
  overflow: hidden;
  border: 1px solid #52ff55;
  border-radius: 12px;
  background: #0a0a0a;
  cursor: pointer;
  transition: all 0.28s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);

  &:hover {
    transform: translateY(-6px) scale(1.03);
    box-shadow: 0 12px 32px rgba(82, 255, 85, 0.18);
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 599px) {
    max-width: 100%;
  }
`;

const CardImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const TitleOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0);
  color: #52ff55;
  font-family: "VT323", "Courier New", Courier, monospace;
  font-size: clamp(1.1rem, 2.8vw, 1.6rem);
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
  transition: background 0.25s ease, opacity 0.25s ease;
  opacity: 0;

  ${Card}:hover & {
    background: rgba(0, 0, 0, 1);
    opacity: 1;
  }

  ${Card}:active & {
    background: rgba(0, 0, 0, 1);
    opacity: 1;
  }
`;

const ReadButton = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.9rem;
  background: #52ff55;
  color: #000;
  font-weight: bold;
  font-size: 0.95rem;
  text-align: center;
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s;

  &:hover {
    background: #6fff6f;
  }
`;

/* ── Featured + denser list layout ─────────────────────────────────────────── */

const formatTopicLabel = (topic) => {
  if (topic === "all") return "All Topics";
  if (topic.toLowerCase() === "ai") return "AI";
  return topic.charAt(0).toUpperCase() + topic.slice(1);
};

const GalleryShell = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 0 16px;

  @media (max-width: 599px) {
    padding: 0 12px;
  }
`;

const ChipBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin: 0.5rem 0 2rem;
`;

const TopicChip = styled.button.attrs({ type: "button" })`
  padding: 0.45rem 0.9rem;
  font-family: "VT323", "Courier New", Courier, monospace;
  font-size: 1.05rem;
  letter-spacing: 0.02em;
  color: ${(p) => (p.$active ? "#000" : "#52ff55")};
  background: ${(p) => (p.$active ? "#52ff55" : "rgba(20, 20, 20, 0.65)")};
  border: 1px solid #52ff55;
  border-radius: 6px;
  cursor: pointer;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: background 0.2s ease, color 0.2s ease, transform 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    background: ${(p) => (p.$active ? "#6fff6f" : "rgba(82, 255, 85, 0.12)")};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(82, 255, 85, 0.25);
  }
`;

const FeaturedCard = styled.button.attrs({ type: "button" })`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  width: 100%;
  min-height: 280px;
  margin-bottom: 1.75rem;
  overflow: hidden;
  border: 1px solid #52ff55;
  border-radius: 12px;
  background: rgba(10, 10, 10, 0.85);
  cursor: pointer;
  text-align: left;
  padding: 0;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.45);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 36px rgba(82, 255, 85, 0.16);
  }

  &:active {
    transform: scale(0.995);
  }

  @media (max-width: 699px) {
    grid-template-columns: 1fr;
    min-height: 0;
  }
`;

const FeaturedMedia = styled.div`
  position: relative;
  min-height: 280px;
  overflow: hidden;

  @media (max-width: 699px) {
    min-height: 200px;
    aspect-ratio: 16 / 10;
  }
`;

const FeaturedImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const FeaturedBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.5rem 1.6rem;
`;

const FeaturedEyebrow = styled.span`
  font-family: "VT323", "Courier New", Courier, monospace;
  font-size: 1rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #52ff55;
  opacity: 0.85;
`;

const FeaturedTitle = styled.h2`
  margin: 0;
  color: #e8ffe9;
  font-family: "VT323", "Courier New", Courier, monospace;
  font-size: clamp(1.55rem, 3.2vw, 2.05rem);
  font-weight: 500;
  line-height: 1.2;
`;

const FeaturedTopics = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 0.25rem;
`;

const MetaChip = styled.span`
  padding: 0.2rem 0.55rem;
  font-family: system-ui, sans-serif;
  font-size: 0.72rem;
  color: #52ff55;
  border: 1px solid rgba(82, 255, 85, 0.45);
  border-radius: 4px;
  background: rgba(82, 255, 85, 0.08);
`;

const FeaturedCta = styled.span`
  margin-top: 0.5rem;
  font-family: "VT323", "Courier New", Courier, monospace;
  font-size: 1.15rem;
  color: #52ff55;
`;

const ArticleList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  @media (min-width: 720px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const ListRow = styled.button.attrs({ type: "button" })`
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 10px;
  border: 1px solid rgba(82, 255, 85, 0.55);
  border-radius: 10px;
  background: rgba(10, 10, 10, 0.72);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: #52ff55;
    background: rgba(82, 255, 85, 0.08);
    transform: translateY(-2px);
  }

  &:active {
    transform: scale(0.99);
  }
`;

const ListThumb = styled.img`
  width: 88px;
  height: 88px;
  object-fit: cover;
  object-position: center;
  border-radius: 6px;
  border: 1px solid rgba(82, 255, 85, 0.35);
`;

const ListBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const ListTitle = styled.span`
  color: #e8ffe9;
  font-family: "VT323", "Courier New", Courier, monospace;
  font-size: 1.15rem;
  line-height: 1.25;
`;

const ListTopics = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const EmptyState = styled.p`
  text-align: center;
  color: #52ff55;
  font-family: "VT323", "Courier New", Courier, monospace;
  font-size: 1.25rem;
  opacity: 0.8;
`;

// ──────────────────────────────────────────────────────────────────────────────
// Component ────────────────────────────────────────────────────────────────────
// ──────────────────────────────────────────────────────────────────────────────

const ArticlesGallery = () => {
  const [selectedTopic, setSelectedTopic] = useState("all");
  const [modalOpen, setModalOpen] = useState(false);
  const [activeArticle, setActiveArticle] = useState(null);

  const articles = useMemo(() => [
    {
      id: 39,
      link: "https://x.com/jrq3rq/status/2035761297183432935",
      imageSrc: Xarticle39,
      title: "My North Star: Designing for Wonder",
      showButton: false,
      topics: ["museums", "innovation", "experience-design", "vision", "personal-development"]
    },
    {
      id: 38,
      link: "https://x.com/jrq3rq/status/1994968885997834701?s=20",
      imageSrc: Xarticle38,
      title: "The Most Beautiful Use of AI Nobody Is Talking About",
      showButton: false,
      topics: ["ai", "culture", "preservation", "innovation", "humanity"]
    },
    {
      id: 37,
      link: "https://x.com/jrq3rq/status/1981435574759120987",
      imageSrc: Xarticle37,
      title: "Insight Without Intrusion: How Psychological Assessments Protect Student Privacy",
      showButton: false,
      topics: ["ai", "education", "psychology", "privacy", "innovation"]
    },
    // {
    //   id: 36,
    //   link: "https://x.com/jrq3rq/status/1942634182209069127",
    //   imageSrc: Xarticle36,
    //   title: "Simple Agents, Big Wins: How Small AI Agents Can Transform Your Business",
    //   showButton: false,
    //   topics: ["business", "ai", "innovation", "technology", "automation"]
    // },
    {
      id: 35,
      link: "https://x.com/jrq3rq/status/1942609360565461411",
      imageSrc: Xarticle35,
      title: "Why Smart Ideas Die Without Systems: Why even the best sparks need a plan to soar.",
      showButton: false,
      topics: ["business", "innovation", "strategy", "systems-thinking"]
    },
    {
      id: 34,
      link: "https://x.com/jrq3rq/status/1939256462532124973",
      imageSrc: Xarticle34,
      title: "Voices of the Magi: A Spiritual Calling in Code",
      showButton: false,
      topics: ["religious", "spirituality", "technology", "ai"]
    },
    {
      id: 33,
      link: "https://x.com/jrq3rq/status/1936664416122208528",
      imageSrc: Xarticle33,
      title: "A Blueprint for Healing Earth: Technologies for a Thriving Planet",
      showButton: false,
      topics: ["environment", "sustainability", "innovation"]
    },
    {
      id: 32,
      link: "https://x.com/jrq3rq/status/1916706569884172749",
      imageSrc: Xarticle32,
      title: "Depth Over Trends: How to Build Success That Lasts",
      showButton: false,
      topics: ["strategy", "success"]
    },
    {
      id: 31,
      link: "https://x.com/jrq3rq/status/1915260038807220678",
      imageSrc: Xarticle31,
      title: "Self-Marketing for Introverts: How to Be Seen Without Selling Your Soul",
      showButton: false,
      topics: ["self-marketing", "individuality", "personality", "psychology"]
    },
    {
      id: 30,
      link: "https://x.com/jrq3rq/status/1904728233649856711",
      imageSrc: Xarticle30,
      title: "Homeschool Guide: Reducing the Mental Load of Homeschooling",
      showButton: false,
      topics: ["ai", "innovation", "autism", "neurodiversity"]
    },
    {
      id: 29,
      link: "https://x.com/jrq3rq/status/1903514303933936056",
      imageSrc: Xarticle29,
      title: "Why Your AI Art Keeps Drawing the Wrong Thing — The Power of Priming",
      showButton: false,
      topics: ["ai", "technology", "psychology", "user-experience", "art", "innovation"]
    },
    {
      id: 28,
      link: "https://x.com/jrq3rq/status/1902089229485920272",
      imageSrc: Xarticle28,
      title: "The Future of Knowledge – Why We’ll Pay to Chat with AI Einsteins",
      showButton: false,
      topics: ["ai", "technology", "innovation", "user-experience", "entertainment", "monetization"]
    },
    {
      id: 27,
      link: "https://x.com/jrq3rq/status/1842974661480710531",
      imageSrc: Xarticle27,
      title: "The Essence of Enchanting Retail: Bringing Back the Magic in Modern Small Shops",
      showButton: false,
      topics: ["retail", "small business", "customer-experience", "sustainability", "innovation", "technology", "experience-design"]
    },
    {
      id: 26,
      link: "https://x.com/jrq3rq/status/1842292716996276693",
      imageSrc: Xarticle26,
      title: "Revolutionizing Play: The Integration of AI in the Toy Industry",
      showButton: false,
      topics: ["ai", "toys", "education", "personalization"]
    },
    {
      id: 24,
      link: "https://x.com/jrq3rq/status/1840806509292503212",
      imageSrc: Xarticle24,
      title: "The Art of Being Uniquely You: Harnessing Individuality in Creativity",
      showButton: false,
      topics: ["creativity", "individuality", "psychology", "personal-development"]
    },
    {
      id: 23,
      link: "https://x.com/jrq3rq/status/1827134562801218044",
      imageSrc: Xarticle23,
      title: "Creating the Future of Experiential Spaces: A Modular, Multi-Sensory Environment",
      showButton: false,
      topics: ["innovation", "technology", "retail", "museums", "experience-design", "ar"]
    },
    {
      id: 22,
      link: "https://x.com/jrq3rq/status/1823894563440013781",
      imageSrc: Xarticle22,
      title: "The Intersection of Art and AI: Navigating New Frontiers in Creative Expression ",
      showButton: false,
      topics: ["ai", "art", "innovation"]
    },
    {
      id: 21,
      link: "https://x.com/jrq3rq/status/1818330358745874787",
      imageSrc: Xarticle21,
      title: "Holographic Storytelling: Interactive Holograms for History and Art ",
      showButton: false,
      topics: ["holography", "art", "museums", "technology", "innovation"]
    },
    {
      id: 14,
      link: "https://x.com/jrq3rq/status/1813033783224070539",
      imageSrc: Xarticle14,
      title: "From Retail Ruins to Museums: How to Transform America's Abandoned Malls",
      showButton: false,
      topics: ["art", "museums", "business", "innovation", "urban-planning"]
    },
    {
      id: 19,
      link: "https://x.com/12jungian/status/1811872575007654071",
      imageSrc: Xarticle19,
      title: "Transforming Today's Museums into Tomorrow's Ivy League: AI as an Educational Tool",
      showButton: false,
      topics: ["ai", "museums", "education", "technology", "innovation"]
    },
    {
      id: 20,
      link: "https://x.com/12jungian/status/1812556682624643569",
      imageSrc: Xarticle20,
      title: "Part 2: Beyond AI – Reshaping the Future of Museums with a Comprehensive Vision",
      showButton: false,
      topics: ["museums", "innovation", "technology", "art", "education"]
    },
    {
      id: 15,
      link: "https://x.com/jrq3rq/status/1814799275647508916",
      imageSrc: Xarticle15,
      title: "The Role and Evolution of Non-Profits in America: A Comprehensive Guide",
      showButton: false,
      topics: ["business", "leadership", "social-impact", "innovation"]
    },
    {
      id: 16,
      link: "https://x.com/jrq3rq/status/1806108757203747184",
      imageSrc: Xarticle16,
      title: "The Dangers of Overconfidence: How Thinking You Know Everything Can Lead to Failure",
      showButton: false,
      topics: ["psychology", "leadership", "business", "personal-development"]
    },
    {
      id: 13,
      link: "https://x.com/jrq3rq/status/1809369493568909601",
      imageSrc: Xarticle13,
      title: "Unlocking Potential: Mastering the Art of Constructive Questioning",
      showButton: false,
      topics: ["leadership", "psychology", "innovation", "business"]
    },
    {
      id: 17,
      link: "https://x.com/jrq3rq/status/1807206985802436854",
      imageSrc: Xarticle17,
      title: "The Lost Magic: Rediscovering the Soul of Walt Disney's World",
      showButton: false,
      topics: ["entertainment", "business", "innovation", "art"]
    },
    {
      id: 18,
      link: "https://x.com/jrq3rq/status/1808322265102405899",
      imageSrc: Xarticle18,
      title: "Understanding the Importance of Skill Development",
      showButton: false,
      topics: ["personal-development", "education", "business", "career"]
    },
    {
      id: 12,
      link: "https://x.com/jrq3rq/status/1805414687204688147",
      imageSrc: Xarticle11,
      title: "Embracing the Infinite: Psychological Patterns in Data Analysis",
      showButton: false,
      topics: ["psychology", "data-analysis"]
    },
    {
      id: 11,
      link: "https://x.com/jrq3rq/status/1804279451192299531",
      imageSrc: Xarticle9,
      title: "Embracing the Infinite: Finding Patterns in a Data-Rich World",
      showButton: false,
      topics: ["data-analysis"]
    },
    {
      id: 1,
      link: "https://x.com/12jungian/status/1797332069313569091",
      imageSrc: Xarticle1,
      title: "Unveiling the Mythic Roots: The Journey of Jungian Archetypes",
      showButton: true,
      topics: ["psychology", "jungian archetypes"],
      content: `
       <h2>Unveiling the Mythic Roots: The Journey of Jungian Archetypes</h2>
        <p>In the vast landscape of psychological exploration, few figures loom as large as Carl Gustav Jung. Jung's pioneering work delved into the depths of the human psyche, unraveling mysteries that had long confounded scholars and laypeople alike. Central to Jung's framework are his theories on archetypes, symbolic patterns deeply ingrained in the collective unconscious of humanity. This article embarks on a journey through the mythic roots of Jungian archetypes, shedding light on their origins, significance, and practical applications in contemporary society.</p>
        <h3>The Collective Unconscious</h3>
        <p>At the core of Jungian psychology lies the concept of the collective unconscious, a reservoir of shared experiences, symbols, and archetypes that transcends individuality. Within this vast repository, archetypes serve as primordial templates, shaping our perceptions, behaviors, and cultural narratives. Through exploring the collective unconscious, we gain insights into the universal aspects of the human condition, uncovering the threads that bind us together across time and space.</p>
        <h3>Mythic Origins of Archetypes</h3>
        <p>The origins of Jungian archetypes can be traced back to the myths and legends of ancient civilizations. From the hero's epic quest for glory to the shadowy depths of the underworld, mythologies from around the world abound with archetypal motifs. These timeless tales, passed down through generations, offer glimpses into the collective soul of humanity, reflecting our deepest fears, aspirations, and desires.</p>
        <h3>The Hero's Journey</h3>
        <p>Among the myriad archetypes that populate the collective unconscious, none is more iconic than the hero. Embarking on a journey of trials and tribulations, the hero confronts inner and outer challenges, ultimately emerging transformed and enlightened. Through the hero's journey, individuals find resonance with their own struggles and triumphs, discovering the courage and resilience within themselves to face life's adversities.</p>
        <h3>The Shadow and the Anima/Animus</h3>
        <p>Yet, alongside the hero, lurks the shadow—a dark and often neglected aspect of the psyche. The shadow represents the repressed and denied parts of ourselves, manifesting in unconscious patterns of behavior and projection onto others. Similarly, the anima (the feminine aspect within men) and animus (the masculine aspect within women) embody the unconscious qualities that we seek to integrate and understand.</p>
        <h3>Archetypes in Modern Culture</h3>
        <p>From the pages of literature to the silver screen, archetypes permeate modern culture, shaping our stories, symbols, and societal norms. Whether in the form of the wise mentor, the femme fatale, or the rebellious outlaw, archetypal characters resonate with audiences on a profound level, tapping into universal truths and collective experiences.</p>
        <h3>Psychological Applications of Archetypes</h3>
        <p>Beyond their cultural significance, archetypes find practical applications in psychology, therapy, and personal development. Therapists utilize archetypal imagery and storytelling to help clients explore and integrate unconscious aspects of their psyche, facilitating healing and transformation. Similarly, personality assessments and self-discovery tools draw upon archetypal frameworks to provide insights into individuals' motivations, strengths, and challenges.</p>
        <h3>Archetypes in Everyday Life</h3>
        <p>In our daily lives, we encounter archetypal patterns in myriad forms, from the nurturing caregiver to the ambitious entrepreneur. These archetypes shape our identities, relationships, and societal roles, influencing how we perceive ourselves and interact with others. By recognizing archetypal dynamics at play, we gain a deeper understanding of human behavior and collective dynamics.</p>
        <h3>The Evolution of Archetypes</h3>
        <p>As society evolves and cultural landscapes shift, archetypes adapt and evolve alongside them. New archetypal figures emerge, reflecting changing social norms, values, and aspirations. Yet, beneath the surface, the core essence of archetypes remains unchanged, serving as timeless symbols of the human experience.</p>
        <h3>Embracing the Archetypal Journey</h3>
        <p>In embracing the archetypal journey, we embark on a path of self-discovery, introspection, and personal growth. By exploring our own archetypal narratives and patterns, we gain insights into our deepest motivations, fears, and potentials. Through this process of integration and individuation, we move towards wholeness and authenticity, aligning with the transformative power of Jungian archetypes.</p>
        <h3>Critique and Counterarguments</h3>
        <p>While Jung's theories on archetypes have had a profound impact on psychology and culture, they are not without critique. Critics argue that archetypes may not be universally applicable, and their meanings may vary significantly across cultures and contexts. Some scholars emphasize the role of broader social and cultural factors that shape human behavior, suggesting that archetypes alone may not fully account for the complexity of the human experience. Despite these criticisms, Jungian archetypes continue to inspire and provoke thought, inviting further exploration and dialogue within the field of psychology and beyond.</p>
      `,
      bottomImage: BottomImage
    },
    {
      id: 2,
      link: "https://x.com/12jungian/status/1797776932492513301",
      imageSrc: Xarticle3,
      title: "Unveiling the Power of Jungian Archetypes: Discovering Business Identity",
      showButton: false,
      topics: ["psychology", "jungian archetypes", "business"]
    },
    {
      id: 3,
      link: "https://x.com/12jungian/status/1798465206026391646",
      imageSrc: Xarticle2,
      title: "Unveiling Creative Potential: Harnessing Archetypes for Innovation and Growth",
      showButton: false,
      topics: ["psychology", "innovation"]
    },
    {
      id: 4,
      link: "https://x.com/jrq3rq/status/1791638597210435907",
      imageSrc: Xarticle0,
      title: "Enhancing AI Alignment with Jungian Archetypes",
      showButton: false,
      topics: ["ai", "psychology", "jungian archetypes"]
    },
    {
      id: 5,
      link: "https://x.com/jrq3rq/status/1803818318215962710",
      imageSrc: Xarticle5,
      title: "Reimagining the Past for the Future: How 2D Nostalgic Games Can Thrive in Web 3",
      showButton: false,
      topics: ["gaming", "web3"]
    },
    {
      id: 6,
      link: "https://x.com/jrq3rq/status/1796719807360127156",
      imageSrc: Xarticle4,
      title: "Revolutionizing the World: The Transformative Power of AI",
      showButton: false,
      topics: ["ai", "technology"]
    },
    {
      id: 7,
      link: "https://x.com/jrq3rq/status/1791210906015166705",
      imageSrc: Xarticle6,
      title: "Interactive Museum and Art Exhibits: Transforming Visitor Experience with AI Characters",
      showButton: false,
      topics: ["ai", "art", "museums"]
    },
    {
      id: 8,
      link: "https://x.com/jrq3rq/status/1801792928899285381",
      imageSrc: Xarticle7,
      title: "Unlocking AI's Full Potential: The Critical Role of Specialized Expertise",
      showButton: false,
      topics: ["ai", "expertise"]
    },
    {
      id: 9,
      link: "https://x.com/jrq3rq/status/1802513058541232262",
      imageSrc: Xarticle8,
      title: "Unlocking Leadership Potential: The Power of Shadow Work in Business",
      showButton: false,
      topics: ["psychology", "business", "leadership"]
    },
    {
      id: 10,
      link: "https://x.com/jrq3rq/status/1804312930244284748",
      imageSrc: Xarticle10,
      title: "How Extroverts Lead the World Built by Introverts: The Yin and Yang of Human Personalities",
      showButton: false,
      topics: ["psychology", "personality"]
    }
  ], []);

  // Only surface topics with enough articles to be useful filters.
  // One-off tags stay on the article cards, but don't clutter the chip bar.
  const MIN_TOPIC_COUNT = 3;

  const filterTopics = useMemo(() => {
    const counts = articles.reduce((acc, article) => {
      article.topics.forEach((topic) => {
        acc[topic] = (acc[topic] || 0) + 1;
      });
      return acc;
    }, {});

    return Object.entries(counts)
      .filter(([, count]) => count >= MIN_TOPIC_COUNT)
      .map(([topic]) => topic)
      .sort((a, b) => a.localeCompare(b));
  }, [articles]);

  const allTopics = useMemo(() => ["all", ...filterTopics], [filterTopics]);

  // If a removed/rare topic was somehow selected, fall back to all
  useEffect(() => {
    if (selectedTopic !== "all" && !filterTopics.includes(selectedTopic)) {
      setSelectedTopic("all");
    }
  }, [filterTopics, selectedTopic]);

  const visibleArticles = useMemo(() => {
    if (selectedTopic === "all") return articles;
    return articles.filter((a) => a.topics.includes(selectedTopic));
  }, [articles, selectedTopic]);

  const featuredArticle = visibleArticles[0] || null;
  const listArticles = visibleArticles.slice(1);

  const openXLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openModal = (article) => {
    if (article.showButton) {
      setActiveArticle(article);
      setModalOpen(true);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveArticle(null);
  };

  const handleCardClick = (article) => {
    if (article.showButton) {
      openModal(article);
    } else {
      openXLink(article.link);
    }
  };

  return (
    <>
      <MainContainer id="Xarticles">
        {USE_FEATURED_LAYOUT ? (
          <GalleryShell>
            <ChipBar>
              {allTopics.map((topic) => (
                <TopicChip
                  key={topic}
                  $active={selectedTopic === topic}
                  onClick={() => setSelectedTopic(topic)}
                  aria-pressed={selectedTopic === topic}
                >
                  {formatTopicLabel(topic)}
                </TopicChip>
              ))}
            </ChipBar>

            {!featuredArticle ? (
              <EmptyState>No articles for this topic.</EmptyState>
            ) : (
              <>
                <FeaturedCard
                  onClick={() => handleCardClick(featuredArticle)}
                  aria-label={`Open featured article: ${featuredArticle.title}`}
                >
                  <FeaturedMedia>
                    <FeaturedImage
                      src={featuredArticle.imageSrc}
                      alt={featuredArticle.title}
                    />
                  </FeaturedMedia>
                  <FeaturedBody>
                    <FeaturedEyebrow>Latest</FeaturedEyebrow>
                    <FeaturedTitle>{featuredArticle.title}</FeaturedTitle>
                    <FeaturedTopics>
                      {featuredArticle.topics.slice(0, 4).map((topic) => (
                        <MetaChip key={topic}>{formatTopicLabel(topic)}</MetaChip>
                      ))}
                    </FeaturedTopics>
                    <FeaturedCta>
                      {featuredArticle.showButton ? "Read article →" : "Open on X →"}
                    </FeaturedCta>
                  </FeaturedBody>
                </FeaturedCard>

                {listArticles.length > 0 && (
                  <ArticleList>
                    {listArticles.map((article) => (
                      <ListRow
                        key={article.id}
                        onClick={() => handleCardClick(article)}
                        aria-label={`Open ${article.title}`}
                      >
                        <ListThumb
                          src={article.imageSrc}
                          alt=""
                          loading="lazy"
                        />
                        <ListBody>
                          <ListTitle>{article.title}</ListTitle>
                          <ListTopics>
                            {article.topics.slice(0, 2).map((topic) => (
                              <MetaChip key={topic}>
                                {formatTopicLabel(topic)}
                              </MetaChip>
                            ))}
                          </ListTopics>
                        </ListBody>
                      </ListRow>
                    ))}
                  </ArticleList>
                )}
              </>
            )}
          </GalleryShell>
        ) : (
          <>
            <FilterBar>
              <TopicSelect
                value={selectedTopic}
                onChange={(e) => setSelectedTopic(e.target.value)}
              >
                {allTopics.map((topic) => (
                  <option key={topic} value={topic}>
                    {formatTopicLabel(topic)}
                  </option>
                ))}
              </TopicSelect>
            </FilterBar>

            <CardsGrid>
              {visibleArticles.map((article) => (
                <Card
                  key={article.id}
                  onClick={() => handleCardClick(article)}
                  aria-label={`Open ${article.title}`}
                >
                  <CardImage
                    src={article.imageSrc}
                    alt={article.title}
                    loading="lazy"
                  />
                  <TitleOverlay>{article.title}</TitleOverlay>

                  {article.showButton && (
                    <ReadButton
                      onClick={(e) => {
                        e.stopPropagation();
                        openModal(article);
                      }}
                    >
                      Read Article
                    </ReadButton>
                  )}
                </Card>
              ))}
            </CardsGrid>
          </>
        )}
      </MainContainer>

      {activeArticle && (
        <ArticleModal
          isOpen={modalOpen}
          onClose={closeModal}
          bottomImage={activeArticle.bottomImage}
        >
          <div dangerouslySetInnerHTML={{ __html: activeArticle.content }} />
        </ArticleModal>
      )}
    </>
  );
};

export default ArticlesGallery;